import type { BrandingStatus, DocumentOperation, SubmissionStatus } from '@root/@types/types';
import { DocumentMode } from '@root/@types/types';
import type { TemplateTransitionStatus } from '@root/helpers/templates/state-transitions';

type DocumentStatuses = {
  [DocumentMode.SUBMISSIONS]: SubmissionStatus[];
  [DocumentMode.ENDORSEMENTS]: SubmissionStatus[];
  [DocumentMode.TEMPLATES]: TemplateTransitionStatus[];
  [DocumentMode.BRANDING]: BrandingStatus[];
};

// Defines which document statuses allow which operations in each document mode
const OPERATIONS_ALLOWED_IN_DOC_STATUS: Record<DocumentOperation, DocumentStatuses> = {
  edit: {
    [DocumentMode.SUBMISSIONS]: ['DRAFT'],
    [DocumentMode.ENDORSEMENTS]: ['DRAFT'],
    [DocumentMode.TEMPLATES]: ['DRAFT'],
    [DocumentMode.BRANDING]: ['DRAFT'],
  },
  'status-change': {
    [DocumentMode.SUBMISSIONS]: ['DRAFT', 'ARCHIVED', 'REVIEW', 'FIRM_ORDER'],
    [DocumentMode.ENDORSEMENTS]: ['DRAFT', 'REVIEW', 'ARCHIVED'],
    [DocumentMode.TEMPLATES]: ['DRAFT', 'REVIEW', 'PUBLISHED', 'ARCHIVED'],
    [DocumentMode.BRANDING]: ['DRAFT', 'PUBLISHED', 'ARCHIVED'],
  },
};

export default OPERATIONS_ALLOWED_IN_DOC_STATUS;
